import * as Long from "long";
import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IdErrorCore } from "../../../constants/IdErrorCore";
import { selectCoopInfo, selectCoopName } from "../../../selectors/selectCoopInfo";
import { selectRankEntry, selectRankingSelectedLanguage } from "../../../selectors/selectRankInfo";
import { StatusCode } from "../../../utils/network/generated/protoTypes";
import { utilRanking } from "../../../utils/utilRanking";
import { actionErrorThrowError } from "../../errors/actionError";
import { actionCoopXpHighScoresPositionRequest, actionCoopXpSelfScoreReceived, TypeActionRanking, } from "../actionRanking";
export var epicCoopXpRankingByName = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionRanking.CoopXpHighSocresNameRequest), switchMap(function (action) {
        var state = state$.value;
        var name = action.nameSearch ? action.nameSearch : selectCoopName(state);
        if (!name) {
            return of(actionCoopXpHighScoresPositionRequest(1));
        }
        var language = selectRankingSelectedLanguage(state);
        var url = utilRanking.getRankingCoopXpUrlByName(name, language ? language.languageCode : undefined);
        return utilRanking.ajaxGetRequest(url);
    }), switchMap(function (res) {
        if (res == undefined) {
            var highScores = selectRankEntry(state$.value);
            if (highScores && highScores.length === 0) {
                return of(actionCoopXpHighScoresPositionRequest(1));
            }
            return of(actionErrorThrowError(IdErrorCore.TextErrors, StatusCode.NAME_INVALID));
        }
        var coop = selectCoopInfo(state$.value);
        var actions = [];
        if (res) {
            if (coop && res.id && Long.fromValue(res.id).equals(coop.id)) {
                actions.push(actionCoopXpSelfScoreReceived(res));
            }
            actions.push(actionCoopXpHighScoresPositionRequest(res.position || 1));
        }
        return from(actions);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/epics/epicCoopXpRankingByName.ts
// module id = 2118
// module chunks = 3